import React from 'react'
import { TestIds } from '../../../../testIds'
import { ItemContainer, ItemLabel } from '../../../../components/styled'

interface RemoveButtonProps {
  onRemove: () => void
}
export const RemoveButton: React.FC<RemoveButtonProps> = ({ onRemove }) => {
  return (
    <ItemContainer wrap={false} sx={{ position: 'absolute', right: 16, top: 16 }}>
      <ItemLabel
        variant='body2'
        align='right'
        sx={{ cursor: 'pointer', textDecoration: 'underline' }}
        onClick={onRemove}
        data-testid={TestIds.feat.product.card.cartRemoveButton}
      >
        Remove
      </ItemLabel>
    </ItemContainer>
  )
}
